export default __webpack_public_path__ + "static/media/amsterdam.cc9ea319.png";